export default __webpack_public_path__ + "static/media/logo-mobile.035eb11c.svg";